module.exports = __webpack_public_path__ + "img/jd.40eb8c63.png";